(function () {
  function moneyFromCents(cents) {
    var value = Number(cents || 0) / 100;
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents);
      }
    } catch (error) {}
    if (!Number.isFinite(value)) value = 0;
    return '$' + value.toFixed(2);
  }

  function openSaDialog(dialog, afterOpen) {
    if (!dialog || typeof dialog.showModal !== 'function' || dialog.open) return;
    try {
      dialog.showModal();
    } catch (error) {
      return;
    }
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        dialog.classList.add('is-open');
        if (typeof afterOpen === 'function') afterOpen();
      });
    });
  }

  function closeSaDialog(dialog) {
    if (!dialog || !dialog.open || dialog.classList.contains('is-closing')) return;
    dialog.classList.add('is-closing');
    dialog.classList.remove('is-open');
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      dialog.removeEventListener('transitionend', onEnd);
      dialog.classList.remove('is-closing');
      if (dialog.open) dialog.close();
    }
    function onEnd(event) {
      if (event.target === dialog) finish();
    }
    dialog.addEventListener('transitionend', onEnd);
    window.setTimeout(finish, 350);
  }

  function bindSaDialog(dialog) {
    if (!dialog || dialog.dataset.saPdpDialogReady === 'true') return;
    dialog.dataset.saPdpDialogReady = 'true';
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeSaDialog(dialog);
    });
    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeSaDialog(dialog);
    });
  }

  function selectedAddons(root) {
    return Array.from(root.querySelectorAll('[data-sa-pdp-addon][data-selected="true"]'));
  }

  function updateSummary(root) {
    var buy = root.querySelector('[data-sa-pdp-buy]');
    if (!buy) return;
    var qtyInput = root.querySelector('[data-sa-pdp-qty-input]');
    var qty = Number((qtyInput && qtyInput.value) || 1);
    var title = buy.getAttribute('data-product-title') || '';
    var mainPrice = Number(buy.getAttribute('data-variant-price') || 0);
    var extrasWrap = buy.querySelector('[data-sa-pdp-summary-extras]');
    var mainTitle = buy.querySelector('[data-sa-pdp-summary-main-title]');
    var mainPriceEl = buy.querySelector('[data-sa-pdp-summary-main-price]');
    var totalEl = buy.querySelector('[data-sa-pdp-summary-total]');
    if (mainTitle) mainTitle.textContent = title + ' × ' + qty;
    if (mainPriceEl) mainPriceEl.textContent = moneyFromCents(mainPrice * qty);
    var total = mainPrice * qty;
    if (extrasWrap) {
      extrasWrap.innerHTML = '';
      var addons = selectedAddons(root);
      extrasWrap.classList.toggle('is-on', addons.length > 0);
      addons.forEach(function (btn) {
        var row = document.createElement('div');
        row.className = 'sa-pdp-buy__row';
        var left = document.createElement('p');
        left.className = 'sa-pdp-buy__name';
        left.textContent = (btn.getAttribute('data-title') || '') + ' × 1';
        var right = document.createElement('p');
        right.className = 'sa-pdp-buy__cost';
        var extraPrice = Number(btn.getAttribute('data-price') || 0);
        right.textContent = btn.getAttribute('data-price-label') || moneyFromCents(extraPrice);
        total += extraPrice;
        row.appendChild(left);
        row.appendChild(right);
        extrasWrap.appendChild(row);
      });
    }
    if (totalEl) totalEl.textContent = moneyFromCents(total);
  }

  function initAddons(root) {
    root.querySelectorAll('[data-sa-pdp-addon]').forEach(function (btn) {
      if (btn.dataset.saPdpAddonReady === 'true') return;
      btn.dataset.saPdpAddonReady = 'true';
      btn.setAttribute('aria-pressed', btn.getAttribute('data-selected') === 'true' ? 'true' : 'false');
      btn.addEventListener('click', function () {
        if (btn.disabled || btn.getAttribute('data-sold-out') === 'true') return;
        if (root.dataset.saPdpBusy === 'true') return;
        var on = btn.getAttribute('data-selected') === 'true';
        btn.setAttribute('data-selected', on ? 'false' : 'true');
        btn.classList.toggle('is-selected', !on);
        btn.setAttribute('aria-pressed', on ? 'false' : 'true');
        updateSummary(root);
      });
    });
  }

  function initEngraving(root) {
    var wrap = root.querySelector('[data-sa-pdp-engraving]');
    if (!wrap) return;
    var openBtn = wrap.querySelector('[data-sa-pdp-engraving-open]');
    var dialog = wrap.querySelector('[data-sa-pdp-engraving-dialog]');
    var field = wrap.querySelector('[data-sa-pdp-engraving-field]');
    var title = wrap.querySelector('[data-sa-pdp-engraving-title]');
    var tools = wrap.querySelector('[data-sa-pdp-engraving-tools]');
    var note = wrap.querySelector('[data-sa-pdp-engraving-note]');
    var removeBtn = wrap.querySelector('[data-sa-pdp-engraving-remove]');
    var input = wrap.querySelector('[data-sa-pdp-engraving-input]');
    var saveBtn = wrap.querySelector('[data-sa-pdp-engraving-save]');
    var remainingEl = wrap.querySelector('[data-sa-pdp-engraving-remaining]');
    var invalidEl = wrap.querySelector('[data-sa-pdp-engraving-invalid]');
    var terms = wrap.querySelector('[data-sa-pdp-engraving-terms]');
    var defaultTitle = title ? title.textContent.trim() : '';
    var maxLength = Number(wrap.getAttribute('data-max-length') || input?.getAttribute('maxlength') || 24);
    var remainingLabel = wrap.getAttribute('data-remaining-label') || 'Characters remaining';
    var invalidLabel = wrap.getAttribute('data-invalid-label') || 'These characters cannot be engraved:';
    var allowed = /^[A-Za-z0-9 .,!?'&\-]$/;

    function invalidChars(value) {
      var found = '';
      var seen = {};
      for (var i = 0; i < value.length; i++) {
        var ch = value.charAt(i);
        if (!allowed.test(ch) && !seen[ch]) {
          seen[ch] = true;
          found += ch;
        }
      }
      return found;
    }

    function syncHints() {
      var value = input ? input.value : '';
      var remaining = Math.max(0, maxLength - value.length);
      if (remainingEl) remainingEl.textContent = remaining + ' ' + remainingLabel + '. ';
      var bad = invalidChars(value);
      if (invalidEl) {
        if (bad) {
          invalidEl.hidden = false;
          invalidEl.textContent = invalidLabel + ' ' + bad;
        } else {
          invalidEl.hidden = true;
          invalidEl.textContent = '';
        }
      }
      if (saveBtn) {
        var trimmed = value.trim();
        saveBtn.disabled = Boolean(trimmed) && terms && !terms.checked;
      }
    }

    function applyValue(value) {
      var has = Boolean(value);
      if (field) {
        field.value = value;
        field.disabled = !has;
      }
      if (title) title.textContent = has ? value : defaultTitle;
      if (tools) tools.classList.toggle('is-on', has);
      if (note) note.classList.toggle('is-on', has);
      if (input) input.value = value;
      syncHints();
    }

    function openDialog() {
      if (!dialog || typeof dialog.showModal !== 'function') return;
      if (input) input.value = field ? field.value : '';
      syncHints();
      openSaDialog(dialog, function () {
        if (input) input.focus();
      });
    }

    function closeDialog() {
      closeSaDialog(dialog);
    }

    bindSaDialog(dialog);

    openBtn?.addEventListener('click', function (event) {
      if (event.target.closest('[data-sa-pdp-engraving-remove]')) return;
      openDialog();
    });

    saveBtn?.addEventListener('click', function () {
      if (saveBtn.disabled) return;
      applyValue((input?.value || '').trim());
      closeDialog();
    });
    wrap.querySelector('[data-sa-pdp-engraving-cancel]')?.addEventListener('click', closeDialog);
    wrap.querySelector('[data-sa-pdp-engraving-clear]')?.addEventListener('click', function () {
      if (input) input.value = '';
      syncHints();
      input?.focus();
    });
    input?.addEventListener('input', syncHints);
    input?.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') event.preventDefault();
    });
    terms?.addEventListener('change', syncHints);

    removeBtn?.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      applyValue('');
    });

    syncHints();
  }

  function initGuarantee(root) {
    var wrap = root.querySelector('[data-sa-pdp-guarantee]');
    if (!wrap) return;
    var dialog = wrap.querySelector('[data-sa-pdp-guarantee-dialog]');
    var tabs = wrap.querySelectorAll('[data-sa-pdp-policy-tab]');
    var panels = wrap.querySelectorAll('[data-sa-pdp-policy-panel]');

    function setTab(id) {
      tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-sa-pdp-policy-tab') === id;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-sa-pdp-policy-panel') !== id;
      });
    }

    wrap.querySelector('[data-sa-pdp-guarantee-open]')?.addEventListener('click', function () {
      openSaDialog(dialog);
    });
    wrap.querySelector('[data-sa-pdp-guarantee-close]')?.addEventListener('click', function () {
      closeSaDialog(dialog);
    });
    bindSaDialog(dialog);
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        setTab(tab.getAttribute('data-sa-pdp-policy-tab'));
      });
    });
  }

  function syncExpand(root) {
    root.querySelectorAll('[data-sa-pdp-expand-root]').forEach(function (wrap) {
      var visible = Number(wrap.getAttribute('data-sa-pdp-visible') || 0);
      var list = wrap.querySelector('[data-sa-pdp-expand-list]');
      if (!list || visible < 1) return;
      var items = Array.prototype.filter.call(list.children, function (el) {
        return el.nodeType === 1;
      });
      items.forEach(function (el, i) {
        if (i >= visible) {
          el.setAttribute('data-sa-pdp-expand-item', '');
          el.classList.add('is-collapsed');
        } else {
          el.removeAttribute('data-sa-pdp-expand-item');
          el.classList.remove('is-collapsed');
        }
      });
      var more = wrap.querySelector('[data-sa-pdp-expand-more]');
      if (more) more.hidden = items.length <= visible;
      var btn = wrap.querySelector('[data-sa-pdp-expand]');
      if (btn) {
        btn.setAttribute('aria-expanded', 'false');
        var label = btn.querySelector('[data-sa-pdp-expand-label]') || btn;
        var moreLabel = btn.getAttribute('data-label-more');
        if (moreLabel) label.textContent = moreLabel;
      }
    });
  }

  function initExpand(root) {
    syncExpand(root);

    root.querySelectorAll('[data-sa-pdp-expand]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wrap = btn.closest('[data-sa-pdp-expand-root]') || root;
        var next = btn.getAttribute('aria-expanded') !== 'true';
        btn.setAttribute('aria-expanded', next ? 'true' : 'false');
        wrap.querySelectorAll('[data-sa-pdp-expand-item]').forEach(function (el) {
          el.classList.toggle('is-collapsed', !next);
        });
        var label = btn.querySelector('[data-sa-pdp-expand-label]') || btn;
        label.textContent = next
          ? btn.getAttribute('data-label-less')
          : btn.getAttribute('data-label-more');
      });
    });
  }

  function initQty(root) {
    root._saPdpSetQty = function (next) {
      var input = root.querySelector('[data-sa-pdp-qty-input]');
      if (!input) return;
      var minus = root.querySelector('[data-sa-pdp-qty-minus]');
      var plus = root.querySelector('[data-sa-pdp-qty-plus]');
      var min = Number(input.min || 1);
      var maxAttr = input.getAttribute('max');
      var max = maxAttr === null || maxAttr === '' ? Infinity : Number(maxAttr);
      var value = Number(next);
      if (!Number.isFinite(value)) value = min;
      value = Math.max(min, Math.floor(value));
      if (Number.isFinite(max)) value = Math.min(max, value);
      input.value = String(value);
      if (minus) minus.disabled = value <= min;
      if (plus) plus.disabled = Number.isFinite(max) && value >= max;
      updateSummary(root);
    };

    if (root.dataset.saPdpQtyBound === 'true') {
      root._saPdpSetQty((root.querySelector('[data-sa-pdp-qty-input]') || {}).value || 1);
      return;
    }
    root.dataset.saPdpQtyBound = 'true';

    root.addEventListener('click', function (event) {
      var minusBtn = event.target.closest('[data-sa-pdp-qty-minus]');
      var plusBtn = event.target.closest('[data-sa-pdp-qty-plus]');
      if (!minusBtn && !plusBtn) return;
      if (!root.contains(minusBtn || plusBtn)) return;
      event.preventDefault();
      var input = root.querySelector('[data-sa-pdp-qty-input]');
      if (!input) return;
      var min = Number(input.min || 1);
      var current = Number(input.value || min);
      if (minusBtn) root._saPdpSetQty(current - 1);
      else root._saPdpSetQty(current + 1);
    });

    root.addEventListener('change', function (event) {
      if (event.target && event.target.matches && event.target.matches('[data-sa-pdp-qty-input]')) {
        root._saPdpSetQty(event.target.value);
      }
    });

    root.addEventListener('keydown', function (event) {
      if (event.target && event.target.matches && event.target.matches('[data-sa-pdp-qty-input]')) {
        if (event.key === 'Enter') {
          event.preventDefault();
          root._saPdpSetQty(event.target.value);
        }
      }
    });

    var initial = root.querySelector('[data-sa-pdp-qty-input]');
    if (initial) root._saPdpSetQty(initial.value || 1);
  }

  function parseMediaAlt(alt) {
    var value = String(alt || '').toLowerCase();
    if (value.indexOf('(') !== -1 || value.indexOf(')') !== -1) {
      var inner = value.split('(').pop();
      if (inner) inner = inner.split(')')[0];
      return '(' + (inner || '') + ')';
    }
    return value;
  }

  function variantFeaturedMediaId(variant) {
    if (!variant) return '';
    if (variant.featured_media && variant.featured_media.id) return String(variant.featured_media.id);
    if (variant.featured_image && variant.featured_image.id) return String(variant.featured_image.id);
    if (variant.image && variant.image.id) return String(variant.image.id);
    return '';
  }

  function pauseHeroMedia(heroMedia) {
    if (!heroMedia) return;
    if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
    heroMedia.querySelectorAll('video').forEach(function (video) {
      try {
        video.pause();
      } catch (error) {}
    });
  }

  function syncGalleryModeButtons(hero, mode) {
    if (!hero) return;
    hero.querySelectorAll('[data-sa-pdp-media-mode]').forEach(function (btn) {
      var key = btn.getAttribute('data-sa-pdp-media-mode');
      if (key !== 'image' && key !== 'video' && key !== 'model') return;
      var active = key === mode;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function configurePdpHeroVideo(heroMedia) {
    if (!heroMedia) return;
    heroMedia.querySelectorAll('video').forEach(function (video) {
      video.muted = true;
      video.loop = true;
      video.controls = false;
      video.setAttribute('muted', '');
      video.setAttribute('loop', '');
      video.setAttribute('playsinline', '');
      video.removeAttribute('controls');
    });
  }

  function playPdpHeroVideo(heroMedia) {
    configurePdpHeroVideo(heroMedia);
    var video = heroMedia && heroMedia.querySelector('video');
    if (!video) return;
    try {
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function () {});
    } catch (error) {}
  }

  function playHeroDeferredMedia(heroMedia) {
    if (!heroMedia) return;
    var deferred = heroMedia.querySelector('.deferred-media, product-model');
    if (deferred && typeof deferred.loadContent === 'function') {
      deferred.loadContent(false);
      window.setTimeout(function () {
        playPdpHeroVideo(heroMedia);
      }, 0);
      return;
    }
    playPdpHeroVideo(heroMedia);
  }

  function saveGalleryImageSnapshot(gallery, hero, heroMedia) {
    if (!gallery || !hero || !heroMedia) return;
    if ((hero.getAttribute('data-media-mode') || 'image') !== 'image') return;
    gallery._saPdpImageHtml = heroMedia.innerHTML;
  }

  function mountHeroMediaView(gallery, mediaId, heroMedia) {
    if (!gallery || !mediaId || !heroMedia) return false;
    pauseHeroMedia(heroMedia);
    heroMedia.innerHTML = '';

    var template = gallery.querySelector('template[data-sa-pdp-media-template][data-media-id="' + mediaId + '"]');
    if (template && template.content) {
      heroMedia.appendChild(template.content.cloneNode(true));
      return heroMedia.childNodes.length > 0;
    }

    var cell = gallery.querySelector('[data-sa-pdp-cell][data-media-id="' + mediaId + '"]');
    if (!cell) return false;
    Array.from(cell.childNodes).forEach(function (node) {
      heroMedia.appendChild(node.cloneNode(true));
    });
    return heroMedia.childNodes.length > 0;
  }

  function syncGalleryViewState(gallery, mode) {
    if (!gallery) return;
    gallery.setAttribute('data-sa-pdp-view', mode || 'image');
  }

  function isGalleryImageItem(el) {
    if (!el) return false;
    var type = el.getAttribute('data-media-type') || 'image';
    return type === 'image';
  }

  function isGalleryThumbVisible(gallery, thumb) {
    if (!isGalleryImageItem(thumb)) return false;
    if (!gallery.hasAttribute('data-variant-media')) return true;
    if (thumb.classList.contains('is-media-variant-alt')) {
      return true;
    }
    return !thumb.classList.contains('is-media-hide');
  }

  function thumbsMatchVariantSrc(el, variantSrc) {
    var full = el.getAttribute('data-full-src') || '';
    if (!full || !variantSrc) return false;
    var fullBase = full.split('?')[0];
    var srcBase = variantSrc.split('?')[0];
    return srcBase.indexOf(fullBase) !== -1 || fullBase.indexOf(srcBase) !== -1;
  }

  function findGalleryThumb(gallery, mediaId, variantSrc) {
    var thumbs = Array.from(gallery.querySelectorAll('[data-sa-pdp-thumb]'));
    if (mediaId) {
      var sameId = thumbs.filter(function (el) {
        return el.getAttribute('data-media-id') === mediaId;
      });
      var visible = sameId.find(function (el) {
        return isGalleryThumbVisible(gallery, el);
      });
      if (visible) return visible;
      if (sameId[0]) return sameId[0];
    }
    if (variantSrc) {
      var visibleMatch = thumbs.find(function (el) {
        return isGalleryThumbVisible(gallery, el) && thumbsMatchVariantSrc(el, variantSrc);
      });
      if (visibleMatch) return visibleMatch;
      return thumbs.find(function (el) {
        return thumbsMatchVariantSrc(el, variantSrc);
      });
    }
    return null;
  }

  function setGalleryMediaMode(root, gallery, mode) {
    var hero = gallery && gallery.querySelector('[data-sa-pdp-hero]');
    if (!hero || !mode) return;
    if (mode !== 'image' && mode !== 'video' && mode !== 'model') return;
    var heroMedia = hero.querySelector('[data-sa-pdp-hero-media]');
    if (!heroMedia) return;

    var prevMode = hero.getAttribute('data-media-mode') || 'image';

    if (mode === 'image') {
      if (prevMode === 'image') return;
      if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
      pauseHeroMedia(heroMedia);
      heroMedia.innerHTML = gallery._saPdpImageHtml || '';
      hero.setAttribute('data-media-mode', 'image');
      hero.setAttribute('data-sa-pdp-zoom', '');
      syncGalleryModeButtons(hero, 'image');
      syncGalleryViewState(gallery, 'image');
      syncGalleryChrome(gallery);
      if (typeof root._saPdpRefreshScene === 'function') root._saPdpRefreshScene();
      return;
    }

    var mediaId = '';
    if (mode === 'video') mediaId = hero.getAttribute('data-video-media-id') || '';
    if (mode === 'model') mediaId = hero.getAttribute('data-model-media-id') || '';
    if (!mediaId) return;

    if (prevMode === mode) {
      playHeroDeferredMedia(heroMedia);
      return;
    }

    if (prevMode === 'image') {
      saveGalleryImageSnapshot(gallery, hero, heroMedia);
    }

    if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
    if (!mountHeroMediaView(gallery, mediaId, heroMedia)) return;

    hero.setAttribute('data-media-mode', mode);
    hero.removeAttribute('data-sa-pdp-zoom');
    syncGalleryModeButtons(hero, mode);
    syncGalleryViewState(gallery, mode);
    syncGalleryChrome(gallery);
    playHeroDeferredMedia(heroMedia);
    if (typeof root._saPdpRefreshScene === 'function') root._saPdpRefreshScene();
  }

  function refreshGalleryModesState(root, gallery) {
    if (!gallery) return;
    var hero = gallery.querySelector('[data-sa-pdp-hero]');
    if (!hero) return;
    delete gallery._saPdpImageHtml;
    saveGalleryImageSnapshot(gallery, hero, hero.querySelector('[data-sa-pdp-hero-media]'));
    var mode = hero.getAttribute('data-media-mode') || 'image';
    syncGalleryModeButtons(hero, mode);
    syncGalleryViewState(gallery, mode);
  }

  function initGalleryMediaModes(root) {
    if (!root || root.dataset.saPdpGalleryModesReady === 'true') return;
    root.dataset.saPdpGalleryModesReady = 'true';
    root.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-sa-pdp-media-mode]');
      if (!btn) return;
      var gallery = btn.closest('[data-sa-pdp-gallery]');
      if (!gallery || !root.contains(gallery)) return;
      event.preventDefault();
      event.stopPropagation();
      setGalleryMediaMode(root, gallery, btn.getAttribute('data-sa-pdp-media-mode'));
    });
  }

  function syncGalleryChrome(gallery) {
    if (!gallery) return;
    var view = gallery.getAttribute('data-sa-pdp-view') || 'image';
    var visibleThumbs = Array.from(gallery.querySelectorAll('[data-sa-pdp-thumb]')).filter(function (thumb) {
      return isGalleryThumbVisible(gallery, thumb);
    });
    var thumbsWrap = gallery.querySelector('.sa-pdp-gallery__thumbs');
    var gridWrap = gallery.querySelector('.sa-pdp-gallery__grid');
    var showChrome = view === 'image' && visibleThumbs.length > 1;
    if (thumbsWrap) thumbsWrap.hidden = !showChrome;
    if (gridWrap) gridWrap.hidden = !showChrome;
  }

  function activateGalleryThumb(root, gallery, thumb, options) {
    if (!gallery || !thumb) return;
    options = options || {};
    if (!options.allowHidden && !isGalleryThumbVisible(gallery, thumb)) return;
    var smooth = options.smooth !== false;
    var scrollThumb = options.scrollThumb !== false;
    var hero = gallery.querySelector('[data-sa-pdp-hero]');
    if (hero && hero.getAttribute('data-media-mode') !== 'image') {
      setGalleryMediaMode(root, gallery, 'image');
    }
    var heroMediaWrap = hero && hero.querySelector('[data-sa-pdp-hero-media]');
    var heroImg = heroMediaWrap && heroMediaWrap.querySelector('img');
    var src = thumb.getAttribute('data-full-src');
    var zoomSrc = thumb.getAttribute('data-zoom-src');
    var mediaId = thumb.getAttribute('data-media-id') || '';
    var mediaAlt = thumb.getAttribute('data-media-alt') || '';

    if (hero) {
      if (mediaId) hero.setAttribute('data-media-id', mediaId);
      if (mediaAlt) hero.setAttribute('data-media-alt', mediaAlt);
    }
    if (heroImg && src) {
      heroImg.src = src;
      heroImg.removeAttribute('srcset');
      if (zoomSrc) heroImg.setAttribute('data-zoom-src', zoomSrc);
      saveGalleryImageSnapshot(gallery, hero, heroMediaWrap);
      if (typeof root._saPdpRefreshScene === 'function') root._saPdpRefreshScene();
    }

    var pressThumb = thumb;
    if (!isGalleryThumbVisible(gallery, thumb) && mediaId) {
      pressThumb =
        Array.from(gallery.querySelectorAll('[data-sa-pdp-thumb]')).find(function (el) {
          return el.getAttribute('data-media-id') === mediaId && isGalleryThumbVisible(gallery, el);
        }) || thumb;
    }
    Array.from(gallery.querySelectorAll('[data-sa-pdp-thumb]')).forEach(function (el) {
      el.setAttribute('aria-pressed', el === pressThumb ? 'true' : 'false');
    });
    Array.from(gallery.querySelectorAll('[data-sa-pdp-cell]')).forEach(function (cell) {
      cell.classList.toggle('is-media-active', cell.getAttribute('data-media-id') === mediaId);
    });
    if (mediaId) gallery.setAttribute('data-active-media-id', mediaId);

    if (
      scrollThumb &&
      smooth &&
      isGalleryThumbVisible(gallery, thumb) &&
      typeof thumb.scrollIntoView === 'function'
    ) {
      thumb.scrollIntoView({
        inline: 'center',
        block: 'nearest',
        behavior: 'smooth'
      });
    }
  }

  function ensureMediaLoaded(el) {
    if (!el) return;
    var images = el.querySelectorAll ? el.querySelectorAll('img') : [];
    if (el.tagName === 'IMG') images = [el];
    Array.from(images).forEach(function (img) {
      if (!img) return;
      if (img.getAttribute('loading') === 'lazy') img.loading = 'eager';
      if (typeof img.decode === 'function') {
        try {
          img.decode().catch(function () {});
        } catch (error) {}
      }
      // Force a load if the browser skipped lazy images while display:none.
      if (!img.complete || img.naturalWidth === 0) {
        var src = img.currentSrc || img.src;
        if (src) {
          var bust = src;
          img.src = bust;
        }
      }
    });
  }

  /* Mirrors media-gallery.setActiveMedia: activate featured media + filter by data-media-alt. */
  function setActiveMedia(root, variant) {
    var gallery = root.querySelector('[data-sa-pdp-gallery]');
    if (!gallery || !variant) return false;

    var mediaId = variantFeaturedMediaId(variant);
    var thumb = findGalleryThumb(gallery, mediaId, variantImageSrc(variant));
    if (!thumb) return false;

    mediaId = thumb.getAttribute('data-media-id') || mediaId;
    var mediaAlt = thumb.getAttribute('data-media-alt') || '';
    if (!mediaAlt && variant.featured_media && variant.featured_media.alt) {
      mediaAlt = parseMediaAlt(variant.featured_media.alt);
    } else if (!mediaAlt && variant.featured_image && variant.featured_image.alt) {
      mediaAlt = parseMediaAlt(variant.featured_image.alt);
    }

    if (gallery.hasAttribute('data-variant-media')) {
      Array.from(gallery.querySelectorAll('[data-sa-pdp-thumb], [data-sa-pdp-cell]')).forEach(function (el) {
        el.classList.remove('is-media-variant-alt', 'is-media-show');
        var type = el.getAttribute('data-media-type') || 'image';
        if (type !== 'image') {
          el.classList.add('is-media-show', 'is-media-variant-alt');
        } else if (mediaAlt && el.getAttribute('data-media-alt') === mediaAlt) {
          el.classList.add('is-media-variant-alt');
          ensureMediaLoaded(el);
        }
      });
    }

    Array.from(gallery.querySelectorAll('[data-sa-pdp-cell]')).forEach(function (cell) {
      cell.classList.remove('is-media-active');
    });

    activateGalleryThumb(root, gallery, thumb, {
      smooth: false,
      scrollThumb: isGalleryThumbVisible(gallery, thumb),
      allowHidden: true
    });
    syncGalleryChrome(gallery);
    return true;
  }

  function initGallery(root) {
    var gallery = root.querySelector('[data-sa-pdp-gallery]');
    if (!gallery) return;
    var thumbs = Array.from(gallery.querySelectorAll('[data-sa-pdp-thumb]'));
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!isGalleryThumbVisible(gallery, thumb)) return;
        activateGalleryThumb(root, gallery, thumb, { smooth: true, scrollThumb: true });
      });
    });
    refreshGalleryModesState(root, gallery);
    syncGalleryChrome(gallery);
    initMediaZoom(gallery);
  }

  function initMediaZoom(gallery) {
    if (!gallery || gallery.hasAttribute('data-sa-pdp-zoom-ready')) return;
    gallery.setAttribute('data-sa-pdp-zoom-ready', '');

    var dialog = document.createElement('dialog');
    dialog.className = 'sa-pdp-gallery__lightbox';
    dialog.setAttribute('aria-label', 'Product image');
    dialog.innerHTML =
      '<button type="button" class="sa-pdp-gallery__lightbox-close" data-sa-pdp-lightbox-close aria-label="Close">' +
      '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false">' +
      '<path d="M2 2l12 12M14 2L2 14" stroke="currentColor" stroke-width="1.2"/>' +
      '</svg></button>' +
      '<button type="button" class="sa-pdp-gallery__lightbox-nav sa-pdp-gallery__lightbox-nav--prev" data-sa-pdp-lightbox-prev aria-label="Previous image">' +
      '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false">' +
      '<path d="M10 3L5 8l5 5" stroke="currentColor" stroke-width="1.2"/>' +
      '</svg></button>' +
      '<button type="button" class="sa-pdp-gallery__lightbox-nav sa-pdp-gallery__lightbox-nav--next" data-sa-pdp-lightbox-next aria-label="Next image">' +
      '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false">' +
      '<path d="M6 3l5 5-5 5" stroke="currentColor" stroke-width="1.2"/>' +
      '</svg></button>' +
      '<div class="swiper sa-pdp-gallery__lightbox-swiper">' +
      '<div class="swiper-wrapper"></div>' +
      '</div>' +
      '<div class="sa-pdp-gallery__lightbox-pagination"></div>';
    gallery.appendChild(dialog);

    var swiperEl = dialog.querySelector('.sa-pdp-gallery__lightbox-swiper');
    var wrapper = dialog.querySelector('.swiper-wrapper');
    var closeBtn = dialog.querySelector('[data-sa-pdp-lightbox-close]');
    var prevBtn = dialog.querySelector('[data-sa-pdp-lightbox-prev]');
    var nextBtn = dialog.querySelector('[data-sa-pdp-lightbox-next]');
    var pagEl = dialog.querySelector('.sa-pdp-gallery__lightbox-pagination');
    var lightboxSwiper = null;
    var viewZoom = null;
    var viewPress = null;
    var lastTapAt = 0;
    var zoomRatio = 2;
    var maxZoom = 4;
    var pointers = {};
    var pinch = null;

    function slides() {
      return Array.from(gallery.querySelectorAll('[data-sa-pdp-thumb]')).filter(function (thumb) {
        return isGalleryThumbVisible(gallery, thumb) && thumb.getAttribute('data-zoom-src');
      });
    }

    function clampPan(img, x, y, scale) {
      var maxX = (img.clientWidth * (scale - 1)) / 2;
      var maxY = (img.clientHeight * (scale - 1)) / 2;
      return {
        x: Math.max(-maxX, Math.min(maxX, x)),
        y: Math.max(-maxY, Math.min(maxY, y))
      };
    }

    function applyViewZoom() {
      if (!viewZoom) return;
      var img = viewZoom.img;
      img.classList.add('is-zoomed');
      img.style.transform =
        'translate3d(' + viewZoom.x + 'px,' + viewZoom.y + 'px,0) scale(' + viewZoom.scale + ')';
    }

    function resetViewZoom() {
      viewZoom = null;
      viewPress = null;
      pinch = null;
      swiperEl.querySelectorAll('.sa-pdp-gallery__lightbox-img').forEach(function (img) {
        img.style.transform = '';
        img.classList.remove('is-zoomed', 'is-panning');
      });
      if (lightboxSwiper && !pinch) lightboxSwiper.allowTouchMove = wrapper.children.length > 1;
    }

    function zoomInAt(img, clientX, clientY) {
      resetViewZoom();
      var rect = img.getBoundingClientRect();
      var pan = clampPan(
        img,
        -(clientX - (rect.left + rect.width / 2)),
        -(clientY - (rect.top + rect.height / 2)),
        zoomRatio
      );
      viewZoom = { img: img, x: pan.x, y: pan.y, scale: zoomRatio, drag: null };
      applyViewZoom();
      if (lightboxSwiper) lightboxSwiper.allowTouchMove = false;
    }

    function touchPoints() {
      return Object.keys(pointers).map(function (id) {
        return pointers[id];
      });
    }

    function pointDistance(a, b) {
      var dx = a.x - b.x;
      var dy = a.y - b.y;
      return Math.sqrt(dx * dx + dy * dy);
    }

    function pointMid(a, b) {
      return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
    }

    function activeLightboxImg(clientX, clientY) {
      var hit = document.elementFromPoint(clientX, clientY);
      var img = hit && hit.closest ? hit.closest('.sa-pdp-gallery__lightbox-img') : null;
      if (img && swiperEl.contains(img)) return img;
      return swiperEl.querySelector('.swiper-slide-active .sa-pdp-gallery__lightbox-img');
    }

    function beginPinch(img, pts) {
      if (!viewZoom || viewZoom.img !== img) {
        viewZoom = { img: img, x: 0, y: 0, scale: 1, drag: null };
      }
      var mid = pointMid(pts[0], pts[1]);
      pinch = {
        startDist: Math.max(pointDistance(pts[0], pts[1]), 1),
        startScale: viewZoom.scale || 1,
        originX: viewZoom.x,
        originY: viewZoom.y,
        mid: mid
      };
      viewPress = null;
      lastTapAt = 0;
      img.classList.add('is-panning');
      if (lightboxSwiper) lightboxSwiper.allowTouchMove = false;
    }

    function movePinch(pts) {
      if (!pinch || !viewZoom || pts.length < 2) return;
      var dist = Math.max(pointDistance(pts[0], pts[1]), 1);
      var scale = pinch.startScale * (dist / pinch.startDist);
      scale = Math.max(1, Math.min(maxZoom, scale));
      var mid = pointMid(pts[0], pts[1]);
      var pan = clampPan(
        viewZoom.img,
        pinch.originX + (mid.x - pinch.mid.x),
        pinch.originY + (mid.y - pinch.mid.y),
        scale
      );
      viewZoom.scale = scale;
      viewZoom.x = pan.x;
      viewZoom.y = pan.y;
      applyViewZoom();
    }

    function endPinch() {
      pinch = null;
      if (!viewZoom) return;
      viewZoom.img.classList.remove('is-panning');
      viewZoom.drag = null;
      if (viewZoom.scale <= 1.02) resetViewZoom();
      else if (lightboxSwiper) lightboxSwiper.allowTouchMove = false;
    }

    function destroyLightboxSwiper() {
      resetViewZoom();
      if (!lightboxSwiper) return;
      lightboxSwiper.destroy(true, true);
      lightboxSwiper = null;
    }

    function fillSlides(list) {
      wrapper.replaceChildren();
      list.forEach(function (thumb) {
        var slide = document.createElement('div');
        slide.className = 'swiper-slide';
        var img = document.createElement('img');
        img.className = 'sa-pdp-gallery__lightbox-img';
        img.alt = thumb.getAttribute('aria-label') || '';
        img.draggable = false;
        img.src = thumb.getAttribute('data-zoom-src');
        slide.appendChild(img);
        wrapper.appendChild(slide);
      });
    }

    function mountSwiper(start, attempt) {
      if (typeof Swiper === 'undefined') {
        if ((attempt || 0) > 40) return;
        window.setTimeout(function () {
          mountSwiper(start, (attempt || 0) + 1);
        }, 50);
        return;
      }
      destroyLightboxSwiper();
      var count = wrapper.children.length;
      lightboxSwiper = new Swiper(swiperEl, {
        initialSlide: start,
        slidesPerView: 1,
        speed: 400,
        loop: count > 1,
        grabCursor: count > 1,
        allowTouchMove: count > 1,
        simulateTouch: true,
        watchOverflow: true,
        navigation:
          count > 1
            ? {
                prevEl: prevBtn,
                nextEl: nextBtn
              }
            : false,
        pagination:
          count > 1
            ? {
                el: pagEl,
                clickable: true
              }
            : false,
        on: {
          slideChange: function () {
            if (pinch) return;
            resetViewZoom();
          }
        }
      });
    }

    bindSaDialog(dialog);
    closeBtn.addEventListener('click', function () {
      closeSaDialog(dialog);
    });
    dialog.addEventListener('close', destroyLightboxSwiper);
    function toggleViewZoom(img, clientX, clientY) {
      if (viewZoom) resetViewZoom();
      else zoomInAt(img, clientX, clientY);
    }
    swiperEl.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      var img = event.target.closest('.sa-pdp-gallery__lightbox-img');
      if (event.pointerType !== 'mouse') {
        pointers[event.pointerId] = {
          x: event.clientX,
          y: event.clientY
        };
        var pts = touchPoints();
        if (pts.length >= 2) {
          var pinchImg = img || activeLightboxImg(pts[0].x, pts[0].y);
          if (pinchImg) beginPinch(pinchImg, pts);
          return;
        }
      }
      if (!img) return;
      viewPress = {
        id: event.pointerId,
        x: event.clientX,
        y: event.clientY,
        img: img,
        moved: false
      };
      if (!viewZoom || event.pointerType !== 'mouse' && pinch) return;
      if (!viewZoom) return;
      viewZoom.drag = {
        id: event.pointerId,
        sx: event.clientX,
        sy: event.clientY,
        ox: viewZoom.x,
        oy: viewZoom.y
      };
      if (swiperEl.setPointerCapture) {
        try {
          swiperEl.setPointerCapture(event.pointerId);
        } catch (error) {}
      }
    });
    swiperEl.addEventListener('pointermove', function (event) {
      if (pointers[event.pointerId]) {
        pointers[event.pointerId].x = event.clientX;
        pointers[event.pointerId].y = event.clientY;
      }
      var pts = touchPoints();
      if (pinch && pts.length >= 2) {
        if (event.cancelable) event.preventDefault();
        movePinch(pts);
        return;
      }
      if (!viewPress || viewPress.id !== event.pointerId) return;
      if (Math.abs(event.clientX - viewPress.x) > 8 || Math.abs(event.clientY - viewPress.y) > 8) {
        viewPress.moved = true;
      }
      if (!viewZoom || !viewZoom.drag || viewZoom.drag.id !== event.pointerId || !viewPress.moved) return;
      viewZoom.img.classList.add('is-panning');
      var pan = clampPan(
        viewZoom.img,
        viewZoom.drag.ox + (event.clientX - viewZoom.drag.sx),
        viewZoom.drag.oy + (event.clientY - viewZoom.drag.sy),
        viewZoom.scale
      );
      viewZoom.x = pan.x;
      viewZoom.y = pan.y;
      applyViewZoom();
    }, { passive: false });
    swiperEl.addEventListener('pointerup', function (event) {
      var wasPinch = !!pinch;
      delete pointers[event.pointerId];
      if (wasPinch) {
        if (touchPoints().length < 2) endPinch();
        viewPress = null;
        return;
      }
      if (viewZoom && viewZoom.drag && viewZoom.drag.id === event.pointerId) {
        viewZoom.drag = null;
        viewZoom.img.classList.remove('is-panning');
      }
      if (!viewPress || viewPress.id !== event.pointerId) return;
      var tapped = viewPress;
      viewPress = null;
      if (tapped.moved) return;
      var now = Date.now();
      if (now - lastTapAt > 450) {
        lastTapAt = now;
        return;
      }
      lastTapAt = 0;
      toggleViewZoom(tapped.img, event.clientX, event.clientY);
    });
    swiperEl.addEventListener('pointercancel', function (event) {
      delete pointers[event.pointerId];
      viewPress = null;
      if (pinch && touchPoints().length < 2) endPinch();
      if (!viewZoom || !viewZoom.drag) return;
      viewZoom.drag = null;
      viewZoom.img.classList.remove('is-panning');
    });
    dialog.addEventListener('keydown', function (event) {
      if (!lightboxSwiper) return;
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        lightboxSwiper.slidePrev();
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        lightboxSwiper.slideNext();
      }
    });

    gallery.addEventListener('click', function (event) {
      if (
        event.target.closest('[data-sa-pdp-thumb]') ||
        event.target.closest('[data-sa-pdp-media-mode]') ||
        event.target.closest('.sa-pdp-gallery__lightbox')
      ) {
        return;
      }
      var frame = event.target.closest('[data-sa-pdp-zoom]');
      if (!frame) return;
      var list = slides();
      if (!list.length) return;
      var mediaId = frame.getAttribute('data-media-id') || '';
      var start = list.findIndex(function (thumb) {
        return thumb.getAttribute('data-media-id') === mediaId;
      });
      if (start < 0) start = 0;
      fillSlides(list);
      var multi = list.length > 1;
      prevBtn.hidden = !multi;
      nextBtn.hidden = !multi;
      pagEl.hidden = !multi;
      openSaDialog(dialog, function () {
        mountSwiper(start);
      });
    });
  }

  function initPay(root) {
    var source = root.querySelector('[data-sa-pdp-pay-source]');
    var slot = root.querySelector('[data-sa-pdp-pay-slot]');
    var row = root.querySelector('.sa-pdp-buy__row-btns');
    if (source && slot && slot.childElementCount === 0) {
      slot.appendChild(source.content.cloneNode(true));
    }
    if (!row || !slot) return;

    function keepInRow(el) {
      return (
        el.classList.contains('sa-pdp-buy__qty') ||
        el.classList.contains('sa-pdp-buy__atc') ||
        el.getAttribute('name') === 'add' ||
        el.querySelector?.('[data-sa-pdp-atc], [name="add"]')
      );
    }

    function sweepPay() {
      Array.from(row.children).forEach(function (el) {
        if (keepInRow(el)) return;
        slot.appendChild(el);
      });
      var atc = root.querySelector('[data-sa-pdp-atc]');
      var available = atc ? !atc.hasAttribute('data-sold-out') : true;
      syncPaymentButtons(root, available);
    }

    sweepPay();
    new MutationObserver(sweepPay).observe(row, { childList: true });
  }

  function stripEasify(root) {
    if (window.TPOConfigs) {
      window.TPOConfigs.product_options_easify = [];
      window.TPOConfigs.product_options = [];
      window.TPOConfigs.product_options_tpo = [];
    }
    root
      .querySelectorAll(
        '.easify-product-options, .easify-product-info, .tpo_option-set-wrapper, .tpo_option, .easify-ai-summary'
      )
      .forEach(function (el) {
        el.remove();
      });
  }

  function variantImageSrc(variant) {
    var image = variant && (variant.featured_image || variant.image);
    if (!image) return '';
    if (typeof image === 'string') return image;
    return image.src || image.url || '';
  }

  function syncPaymentButtons(root, available) {
    var slot = root.querySelector('[data-sa-pdp-pay-slot]');
    if (!slot) return;
    slot.querySelectorAll('.shopify-payment-button').forEach(function (wrap) {
      wrap.classList.toggle('shopify-payment-button--disable', !available);
    });
    slot.querySelectorAll('shopify-accelerated-checkout').forEach(function (el) {
      el.classList.toggle('sa-pdp-pay--disabled', !available);
    });
    slot.querySelectorAll('.shopify-payment-button__button, button').forEach(function (btn) {
      if (!available) {
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('aria-disabled', 'true');
      } else {
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-disabled');
      }
    });
  }

  function syncAddButtons(root, available) {
    var buttons = [
      root.querySelector('[data-sa-pdp-atc]'),
      document.querySelector('[data-sa-pdp-sticky-atc]')
    ];
    buttons.forEach(function (btn) {
      if (!btn) return;
      if (available) btn.removeAttribute('data-sold-out');
      else btn.setAttribute('data-sold-out', 'true');
      if (btn.dataset.saPdpLocked === 'true' || root.dataset.saPdpBusy === 'true') {
        btn.disabled = true;
      } else {
        btn.disabled = !available;
      }
      var label = btn.querySelector('[data-sa-pdp-atc-label]');
      if (!label) {
        if (btn.classList.contains('is-loading') || btn.classList.contains('loading')) return;
        label = btn;
      }
      var text = available
        ? btn.getAttribute('data-add-label') || label.textContent
        : btn.getAttribute('data-sold-out-label') || 'Sold Out';
      label.textContent = text;
    });
    syncPaymentButtons(root, available);
  }

  function applyVariant(root, variant) {
    if (!variant) return;
    var form = root.querySelector('form[data-type="add-to-cart-form"]');
    var idInput = form && form.querySelector('input[name="id"]');
    if (idInput) {
      idInput.value = variant.id;
      try {
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (error) {}
    }

    var priceLabel = moneyFromCents(variant.price);
    var compareLabel =
      variant.compare_at_price > variant.price ? moneyFromCents(variant.compare_at_price) : '';

    var buy = root.querySelector('[data-sa-pdp-buy]');
    if (buy) {
      buy.setAttribute('data-variant-id', String(variant.id));
      buy.setAttribute('data-variant-price', String(variant.price || 0));
      buy.setAttribute('data-price-label', priceLabel);
      updateSummary(root);
    }
    syncAddButtons(root, Boolean(variant.available));

      var qtyInput = root.querySelector('[data-sa-pdp-qty-input]');
      if (qtyInput) {
        var tracked =
          Boolean(variant.inventory_management) && variant.inventory_policy !== 'continue';
        if (tracked && variant.inventory_quantity != null) {
          var maxQty = Math.max(1, Number(variant.inventory_quantity) || 1);
          qtyInput.setAttribute('max', String(maxQty));
          if (Number(qtyInput.value || 1) > maxQty) qtyInput.value = String(maxQty);
        } else {
          qtyInput.removeAttribute('max');
        }
        if (typeof root._saPdpSetQty === 'function') root._saPdpSetQty(qtyInput.value || 1);
      }
    var skuEl = root.querySelector('[data-sa-pdp-sku]');
    if (skuEl) {
      var sku = variant.sku ? String(variant.sku).trim() : '';
      skuEl.textContent = sku;
      var skuRow = skuEl.closest('[data-sa-pdp-sku-row]') || skuEl;
      skuRow.hidden = !sku;
    }
    var specEl = root.querySelector('[data-sa-pdp-spec]');
    if (specEl) {
      var spec = variant.spec_line ? String(variant.spec_line).trim() : '';
      if (!spec) spec = (specEl.getAttribute('data-sa-pdp-spec-fallback') || '').trim();
      specEl.textContent = spec;
      specEl.hidden = !spec;
    }
    root.querySelectorAll('[data-sa-pdp-variant-html]').forEach(function (slot) {
      var holder = slot.parentElement;
      if (!holder) return;
      var mapEl = holder.querySelector('[data-sa-pdp-variant-html-map]');
      if (!mapEl) return;
      var htmlMap;
      try {
        htmlMap = JSON.parse(mapEl.textContent);
      } catch (error) {
        return;
      }
      var nextHtml = htmlMap[String(variant.id)];
      if (nextHtml && String(nextHtml).trim()) {
        slot.innerHTML = nextHtml;
      } else {
        var fallbackEl = holder.querySelector('[data-sa-pdp-variant-html-fallback]');
        slot.innerHTML = fallbackEl ? fallbackEl.innerHTML : '';
      }
    });
    syncExpand(root);
    root.querySelectorAll('[data-sa-pdp-style-with]').forEach(function (list) {
      var slot = list.querySelector('[data-sa-pdp-variant-html]');
      if (!slot) return;
      list.hidden = !slot.querySelector('[data-sa-pdp-addon]');
    });
    initAddons(root);
    updateSummary(root);
    var priceNow = root.querySelector('.sa-pdp-price__now');
    if (priceNow) priceNow.textContent = priceLabel;
    var priceWas = root.querySelector('.sa-pdp-price__was');
    if (priceWas) {
      if (compareLabel) {
        priceWas.textContent = compareLabel;
        priceWas.hidden = false;
      } else {
        priceWas.hidden = true;
      }
    }

    setActiveMedia(root, variant);

    var src = variantImageSrc(variant);
    var stickyImg = document.querySelector('.sa-pdp-sticky__image img');
    if (stickyImg && src) {
      stickyImg.src = src;
      stickyImg.removeAttribute('srcset');
    }
    var stickyNow = document.querySelector('.sa-pdp-sticky__now');
    if (stickyNow) stickyNow.textContent = priceLabel;
    var stickyWas = document.querySelector('.sa-pdp-sticky__was');
    if (stickyWas) {
      if (compareLabel) {
        stickyWas.textContent = compareLabel;
        stickyWas.hidden = false;
      } else {
        stickyWas.hidden = true;
      }
    }
    var stickyVariant = document.querySelector('.sa-pdp-sticky__variant');
    if (stickyVariant && variant.title) stickyVariant.textContent = variant.title;
  }

  function selectedVariantFromStyles(wrap) {
    var dataEl = wrap.querySelector('[data-sa-pdp-variant-data]');
    var variants = [];
    if (dataEl && dataEl.textContent) {
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (error) {
        variants = [];
      }
    }
    var groups = Array.from(wrap.querySelectorAll('.sa-pdp-styles__group'));
    return variants.find(function (variant) {
      if (!variant || !variant.options) return false;
      return groups.every(function (group, index) {
        var checked = group.querySelector('input[type="radio"]:checked');
        return checked ? variant.options[index] === checked.value : true;
      });
    });
  }

  function setVariantLoading(root, on) {
    root.classList.toggle('is-variant-loading', on);
    if (root.dataset.saPdpBusy === 'true') return;
    var buttons = [
      root.querySelector('[data-sa-pdp-atc]'),
      document.querySelector('[data-sa-pdp-sticky-atc]')
    ];
    buttons.forEach(function (btn) {
      if (!btn) return;
      if (on) {
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
      } else {
        btn.removeAttribute('aria-busy');
        if (btn.getAttribute('data-sold-out') !== 'true') btn.disabled = false;
      }
    });
  }

  function replaceSelect(destRoot, sourceRoot, selector) {
    var dest = destRoot.querySelector(selector);
    var source = sourceRoot.querySelector(selector);
    if (!dest || !source) return false;
    dest.replaceWith(source.cloneNode(true));
    return true;
  }

  function fetchVariantSection(root, wrap, variant, input) {
    if (!variant || !variant.id) return;
    var sectionId = root.getAttribute('data-section');
    var productUrl = root.getAttribute('data-url') || window.location.pathname;
    if (!sectionId) {
      applyVariant(root, variant);
      return;
    }

    if (wrap._variantFetch && typeof wrap._variantFetch.abort === 'function') {
      wrap._variantFetch.abort();
    }
    var controller = new AbortController();
    wrap._variantFetch = controller;
    setVariantLoading(root, true);

    var fetchUrl = new URL(productUrl, window.location.origin);
    fetchUrl.searchParams.set('variant', String(variant.id));
    fetchUrl.searchParams.set('section_id', sectionId);

    fetch(fetchUrl.toString(), { signal: controller.signal })
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        if (wrap._variantFetch !== controller) return;
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var nextRoot = doc.querySelector('[data-sa-pdp]');
        if (nextRoot) {
          var nextStyles = nextRoot.querySelector('[data-sa-pdp-styles]');
          if (nextStyles && nextStyles.innerHTML) wrap.innerHTML = nextStyles.innerHTML;
          if (replaceSelect(root, nextRoot, '[data-sa-pdp-gallery]')) {
            initGallery(root);
            var freshGallery = root.querySelector('[data-sa-pdp-gallery]');
            if (freshGallery) delete freshGallery._saPdpImageHtml;
            setActiveMedia(root, variant);
            if (typeof root._saPdpRefreshScene === 'function') root._saPdpRefreshScene();
          }
          replaceSelect(root, nextRoot, '[data-sa-pdp-price]');
        }
        applyVariant(root, variant);
        try {
          var loc = new URL(window.location.href);
          loc.searchParams.set('variant', String(variant.id));
          history.replaceState({}, '', loc.pathname + loc.search);
        } catch (error) {}
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        applyVariant(root, variant);
      })
      .finally(function () {
        if (wrap._variantFetch !== controller) return;
        wrap._variantFetch = null;
        setVariantLoading(root, false);
        applyVariant(root, variant);
        var focusTarget = input;
        if (input && input.id && wrap && !wrap.contains(input)) {
          focusTarget = wrap.querySelector('[id="' + String(input.id).replace(/"/g, '') + '"]');
        }
        if (focusTarget && typeof focusTarget.focus === 'function') {
          try {
            focusTarget.focus();
          } catch (error) {}
        }
      });
  }

  function initStyles(root) {
    var wrap = root.querySelector('[data-sa-pdp-styles]');
    if (!wrap) return;
    wrap.addEventListener('change', function (event) {
      var input = event.target;
      if (!input || input.type !== 'radio') return;
      var nextUrl = input.getAttribute('data-product-url');
      if (nextUrl) {
        try {
          var next = new URL(nextUrl, window.location.origin);
          if (next.pathname !== window.location.pathname) {
            var linked = selectedVariantFromStyles(wrap);
            window.location.href = next.pathname + (linked && linked.id ? '?variant=' + linked.id : '');
            return;
          }
        } catch (error) {}
      }
      var nextVariant = selectedVariantFromStyles(wrap);
      if (!nextVariant) return;
      fetchVariantSection(root, wrap, nextVariant, input);
    });
  }

  function initScene(root) {
    var scene = root.querySelector('[data-sa-pdp-scene]');
    var col = root.querySelector('.sa-pdp__gallery-col');
    if (!scene || !col) return;

    function syncScene() {
      var hero = root.querySelector('[data-sa-pdp-hero]');
      if (!hero) return;
      var pad = parseFloat(window.getComputedStyle(col).paddingTop) || 0;
      var height = hero.getBoundingClientRect().height;
      if (height < 1) {
        var img = hero.querySelector('img');
        var heroWidth = hero.clientWidth || hero.getBoundingClientRect().width;
        if (img && img.naturalWidth > 0 && heroWidth > 0) {
          height = (img.naturalHeight / img.naturalWidth) * heroWidth;
        } else if (root._saPdpSceneHeight) {
          return;
        }
      }
      var next = Math.round(height + pad);
      if (next <= pad && root._saPdpSceneHeight) return;
      root._saPdpSceneHeight = next;
      scene.style.height = next + 'px';
    }

    function bindSceneHero() {
      if (root._saPdpSceneObserver) {
        root._saPdpSceneObserver.disconnect();
        root._saPdpSceneObserver = null;
      }
      var hero = root.querySelector('[data-sa-pdp-hero]');
      if (!hero) return;
      if (typeof ResizeObserver === 'function') {
        root._saPdpSceneObserver = new ResizeObserver(syncScene);
        root._saPdpSceneObserver.observe(hero);
        root._saPdpSceneObserver.observe(col);
      }
      var img = hero.querySelector('img');
      if (img && !img.complete) {
        img.addEventListener('load', syncScene, { once: true });
      }
    }

    root._saPdpSceneSync = syncScene;
    root._saPdpRefreshScene = function () {
      bindSceneHero();
      syncScene();
    };

    root._saPdpRefreshScene();

    if (!root._saPdpSceneResizeBound) {
      root._saPdpSceneResizeBound = true;
      window.addEventListener('resize', function () {
        if (typeof root._saPdpSceneSync === 'function') root._saPdpSceneSync();
      });
    }
  }

  function clearAddonSelection(root) {
    selectedAddons(root).forEach(function (btn) {
      btn.setAttribute('data-selected', 'false');
      btn.classList.remove('is-selected');
      btn.setAttribute('aria-pressed', 'false');
    });
    updateSummary(root);
  }

  var adding = false;
  var ERROR_HIDE_MS = 5000;
  var errorHideTimers = new WeakMap();

  function cart() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function cartAddUrl() {
    return (window.routes && window.routes.cart_add_url) || (typeof routes !== 'undefined' && routes.cart_add_url);
  }

  function sectionIds() {
    var cartDrawer = document.querySelector('cart-drawer');
    var cartNotification = document.querySelector('cart-notification');
    var drawerSections = cartDrawer && cartDrawer.getSectionsToRender ? cartDrawer.getSectionsToRender() : [];
    var notificationSections =
      cartNotification && cartNotification.getSectionsToRender ? cartNotification.getSectionsToRender() : [];
    var ids = [];
    drawerSections.concat(notificationSections).forEach(function (section) {
      if (section && section.id && ids.indexOf(section.id) === -1) ids.push(section.id);
    });
    return ids;
  }

  function fetchConfigJavascript() {
    if (typeof fetchConfig !== 'function') {
      throw new Error('Missing fetchConfig');
    }
    var config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    return config;
  }

  function atcButtons(root) {
    return [root.querySelector('[data-sa-pdp-atc]'), document.querySelector('[data-sa-pdp-sticky-atc]')].filter(
      Boolean
    );
  }

  function setLock(root, active, on) {
    root.dataset.saPdpBusy = on ? 'true' : '';
    atcButtons(root).forEach(function (btn) {
      var isActive = btn === active;
      if (btn.hasAttribute('data-sa-pdp-atc')) {
        btn.classList.toggle('loading', Boolean(on && isActive));
        if (on && isActive) btn.setAttribute('aria-disabled', 'true');
        else if (!on) btn.removeAttribute('aria-disabled');
        var spinner = btn.querySelector('.loading-overlay__spinner');
        if (spinner) spinner.classList.toggle('hidden', !(on && isActive));
      }
      if (btn.hasAttribute('data-sa-pdp-sticky-atc')) {
        btn.classList.toggle('is-loading', Boolean(on && isActive));
        if (on && isActive) btn.setAttribute('aria-disabled', 'true');
        else btn.removeAttribute('aria-disabled');
        if (!on) delete btn.dataset.saPdpPending;
      }
      if (on && isActive) return;
      if (on) {
        btn.dataset.saPdpLocked = 'true';
        btn.disabled = true;
      } else {
        delete btn.dataset.saPdpLocked;
        if (btn.getAttribute('data-sold-out') !== 'true') btn.disabled = false;
      }
    });
  }

  function isStickyAtc(button) {
    return Boolean(button && button.hasAttribute && button.hasAttribute('data-sa-pdp-sticky-atc'));
  }

  function scrollToBuyError(root) {
    var target =
      root.querySelector('.sa-pdp-buy__error:not([hidden])') ||
      root.querySelector('.product-form__error-message-wrapper') ||
      root.querySelector('.sa-pdp-buy__actions');
    if (!target) return;

    window.setTimeout(function () {
      requestAnimationFrame(function () {
        var headerOffset = 96;
        var pdp = root.closest('.sa-pdp') || root;
        var stickyTop = window.getComputedStyle(pdp).getPropertyValue('--pdp-sticky-top');
        if (stickyTop) headerOffset = parseFloat(stickyTop) || headerOffset;

        var bar = document.querySelector('.sa-pdp-sticky__bar');
        var bottomInset = bar ? bar.getBoundingClientRect().height + 24 : 24;
        var rect = target.getBoundingClientRect();
        var viewportRoom = window.innerHeight - headerOffset - bottomInset;
        var offsetInView = Math.max(0, (viewportRoom - rect.height) / 2);
        var top = window.scrollY + rect.top - headerOffset - offsetInView;

        window.scrollTo({
          top: Math.max(0, top),
          behavior: 'smooth'
        });
      });
    }, 80);
  }

  function clearBuyErrorTimer(root) {
    var timer = errorHideTimers.get(root);
    if (timer) clearTimeout(timer);
    errorHideTimers.delete(root);
  }

  function showBuyError(root, message, options) {
    options = options || {};
    var wrap = root.querySelector('.product-form__error-message-wrapper');
    var el = wrap && wrap.querySelector('.product-form__error-message');
    if (!wrap || !el) return;

    clearBuyErrorTimer(root);

    if (!message) {
      wrap.setAttribute('hidden', '');
      el.textContent = '';
      return;
    }

    wrap.removeAttribute('hidden');
    el.textContent = message;

    if (options.scrollToBuy) scrollToBuyError(root);

    if (options.autoHide === false) return;

    var hideMs = Number(options.duration) > 0 ? Number(options.duration) : ERROR_HIDE_MS;
    var timer = setTimeout(function () {
      showBuyError(root, '');
    }, hideMs);
    errorHideTimers.set(root, timer);
  }

  function failMessage() {
    return (window.cartStrings && window.cartStrings.error) || 'Unable to add this item to your cart.';
  }

  function postCart(body) {
    var url = cartAddUrl();
    if (!url) return Promise.reject(new Error('Missing cart add URL'));
    var config = fetchConfigJavascript();
    config.body = body;
    return fetch(url, config).then(function (response) {
      return response.json();
    });
  }

  function renderCart(response) {
    var miniCart = cart();
    if (!miniCart || typeof miniCart.renderContents !== 'function') {
      if (window.routes && window.routes.cart_url) window.location = window.routes.cart_url;
      return;
    }
    try {
      if (miniCart.classList.contains('is-empty')) miniCart.classList.remove('is-empty');
      miniCart.renderContents(response);
    } catch (error) {
      console.error(error);
    }
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'sa-main-product',
          productVariantId: response.variant_id || response.id
        });
      }
    } catch (error) {}
    document.dispatchEvent(new CustomEvent('cart:add:success', { detail: { source: 'sa-main-product' } }));
  }

  function addVariantToCart(variantId, includeSections) {
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    formData.append('sections_url', window.location.pathname);
    if (includeSections) {
      var ids = sectionIds();
      if (ids.length) formData.append('sections', ids.join(','));
    }
    return postCart(formData);
  }

  function addSelectedAddons(root, fromSticky) {
    var addons = selectedAddons(root);
    if (!addons.length) return Promise.resolve(null);

    return addons.reduce(function (chain, btn) {
      return chain.then(function () {
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return null;
        return addVariantToCart(variantId, false).then(function (response) {
          if (response.status) {
            var msg = response.description || failMessage();
            showBuyError(root, msg, { scrollToBuy: fromSticky });
            var error = new Error(msg);
            error.shown = true;
            return Promise.reject(error);
          }
          return response;
        });
      });
    }, Promise.resolve(null));
  }

  function addForm(root, form, fromSticky) {
    var formData = new FormData(form);
    formData.append('sections_url', window.location.pathname);
    var ids = sectionIds();
    if (ids.length) formData.append('sections', ids.join(','));
    return postCart(formData).then(function (response) {
      if (response.status) {
        var msg = response.description || failMessage();
        showBuyError(root, msg, { scrollToBuy: fromSticky });
        var error = new Error(msg);
        error.shown = true;
        return Promise.reject(error);
      }
      return addSelectedAddons(root, fromSticky).then(function () {
        renderCart(response);
        clearAddonSelection(root);
      });
    });
  }

  function runAdd(root, active, request) {
    if (adding || root.dataset.saPdpBusy === 'true') return;
    if (active && (active.disabled || active.getAttribute('aria-disabled') === 'true')) return;
    var fromSticky = isStickyAtc(active);
    adding = true;
    showBuyError(root, '');
    setLock(root, active, true);
    var promise;
    try {
      promise = request();
    } catch (error) {
      adding = false;
      setLock(root, null, false);
      showBuyError(root, failMessage(), { scrollToBuy: fromSticky });
      return;
    }
    if (!promise || typeof promise.then !== 'function') {
      adding = false;
      setLock(root, null, false);
      return;
    }
    promise
      .catch(function (error) {
        if (error && error.shown) return;
        showBuyError(root, failMessage(), { scrollToBuy: fromSticky });
      })
      .finally(function () {
        adding = false;
        setLock(root, null, false);
      });
  }

  function initAtc(root) {
    if (!root || root.dataset.saPdpAtcReady === 'true') return;
    root.dataset.saPdpAtcReady = 'true';

    var form = root.querySelector('form[data-type="add-to-cart-form"]');
    if (form) {
      form.addEventListener(
        'submit',
        function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          try {
            var submitter = event.submitter || root.querySelector('[data-sa-pdp-atc]');
            var fromSticky = isStickyAtc(submitter);
            runAdd(root, submitter, function () {
              return addForm(root, form, fromSticky);
            });
          } catch (error) {
            console.error(error);
            adding = false;
            setLock(root, null, false);
          }
        },
        true
      );
    }

    var stickyAtc = document.querySelector('[data-sa-pdp-sticky-atc]');
    if (stickyAtc && stickyAtc.dataset.saPdpStickyReady !== 'true') {
      stickyAtc.dataset.saPdpStickyReady = 'true';
      stickyAtc.addEventListener('click', function (event) {
        event.preventDefault();
        if (
          stickyAtc.disabled ||
          stickyAtc.getAttribute('aria-disabled') === 'true' ||
          stickyAtc.classList.contains('is-loading') ||
          root.dataset.saPdpBusy === 'true'
        ) {
          return;
        }
        if (!form) return;
        runAdd(root, stickyAtc, function () {
          return addForm(root, form, true);
        });
      });
    }
  }

  function initPdp(root) {
    if (!root || root.dataset.saPdpReady === 'true') return;
    root.dataset.saPdpReady = 'true';
    stripEasify(root);
    new MutationObserver(function () {
      stripEasify(root);
    }).observe(root, { childList: true, subtree: true });
    initGalleryMediaModes(root);
    initGallery(root);
    initScene(root);
    initStyles(root);
    initEngraving(root);
    initGuarantee(root);
    initExpand(root);
    initAddons(root);
    initQty(root);
    initPay(root);
    updateSummary(root);
    initAtc(root);
  }

  function start(scope) {
    var roots = scope?.querySelectorAll
      ? Array.from(scope.querySelectorAll('[data-sa-pdp]'))
      : [];
    if (scope?.matches?.('[data-sa-pdp]')) roots.unshift(scope);
    if (!scope) roots = Array.from(document.querySelectorAll('[data-sa-pdp]'));
    roots.forEach(initPdp);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      start(document);
    });
  } else {
    start(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    start(event.target);
  });

  window.SaPdp = {
    selectedAddons: selectedAddons,
    updateSummary: updateSummary,
    clearAddonSelection: clearAddonSelection
  };
})();